import Vue from 'vue';

export default class PageTitleImage {
    constructor(){
        this.data = Vue.observable({ image:null });
    }

    get() {
        return this.data.image;
    }

    has() {
        return !(this.data.image === null);
    }

    remove() {
        this.data.image = null;
    }

    set(imageurl) {
        this.data.image = imageurl;
    }
}
